import { ParsedUrlQuery } from 'querystring'

/**
 * Next.RouterのqueryからparamをNumber型で取得する
 */
export const getNumberQueryParam = (query: ParsedUrlQuery, key: string) => {
  if (query === undefined) return undefined
  const param = query[key]
  if (param === undefined) return undefined
  const value = Array.isArray(param) ? param[0] : param
  const numValue = Number.isNaN(Number(value)) ? undefined : Number(value)
  return numValue
}
/**
 * Next.RouterのqueryからparamをString型で取得する
 */
export const getStringQueryParam = (query: ParsedUrlQuery, key: string) => {
  if (query === undefined) return undefined
  const param = query[key]
  if (param === undefined) return undefined
  const value = Array.isArray(param) ? param[0] : param
  return value
}
/**
 * Next.RouterのqueryからparamをString[]型で取得する
 */
export const getStringArrayQueryParam = (
  query: ParsedUrlQuery,
  key: string
) => {
  if (query === undefined) return undefined
  const param = query[key]
  if (param === undefined) return undefined
  const value = Array.isArray(param) ? param : [param]
  return value
}

/**
 * 指定したkeysからなるquery文字列を生成する(?key1=value1&key2=value2...)
 * {}の場合は空文字が返される
 * @param query
 * @param keys
 */
export const getQueryStrings = (query: ParsedUrlQuery, keys: string[]) => {
  return Object.entries(query)
    .reduce((prev, curr) => {
      if (keys.some((e) => e === curr[0])) {
        return `${prev}${curr[0]}=${curr[1]}&`
      } else {
        return prev
      }
    }, '?')
    .slice(0, -1)
}
